(() => {
  'use strict';

  if (window.GoshkoCustomerLove) {
    window.GoshkoCustomerLove.setup(document);
    return;
  }

  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const setupCarousel = (carousel) => {
    if (carousel.dataset.gspReady === 'true') return;
    carousel.dataset.gspReady = 'true';

    const viewport = carousel.querySelector('[data-gsp-love-viewport]');
    const cards = qsa('[data-gsp-love-card]', carousel);
    const dots = qsa('[data-gsp-love-dot]', carousel);
    const previous = carousel.querySelector('[data-gsp-love-prev]');
    const next = carousel.querySelector('[data-gsp-love-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplay = carousel.dataset.autoplay === 'true' && !reducedMotion.matches;
    const delay = Math.max(3, Number(carousel.dataset.speed) || 5) * 1000;
    let activeIndex = 0;
    let animationFrame = 0;
    let timer = 0;
    let paused = false;

    if (!viewport || cards.length === 0) return;

    const cardPosition = (card) => card.offsetLeft - cards[0].offsetLeft;
    const nearestIndex = () => {
      let nearest = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      cards.forEach((card, index) => {
        const distance = Math.abs(cardPosition(card) - viewport.scrollLeft);
        if (distance < nearestDistance) {
          nearest = index;
          nearestDistance = distance;
        }
      });
      return nearest;
    };

    const updatePagination = () => {
      activeIndex = nearestIndex();
      dots.forEach((dot, index) => {
        const selected = index === activeIndex;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', String(selected));
      });
    };

    const goTo = (requestedIndex, wrap = false) => {
      let index = requestedIndex;
      if (wrap) index = (index + cards.length) % cards.length;
      else index = Math.max(0, Math.min(cards.length - 1, index));
      activeIndex = index;
      viewport.scrollTo({
        left: cardPosition(cards[index]),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === index;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', String(selected));
      });
    };

    const stopAutoplay = () => {
      if (timer) window.clearInterval(timer);
      timer = 0;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay || paused || document.hidden || cards.length < 2) return;
      timer = window.setInterval(() => goTo(nearestIndex() + 1, true), delay);
    };

    const pause = () => {
      paused = true;
      stopAutoplay();
    };

    const resume = () => {
      paused = false;
      startAutoplay();
    };

    previous?.addEventListener('click', () => {
      goTo(nearestIndex() - 1, true);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      goTo(nearestIndex() + 1, true);
      startAutoplay();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      goTo(Number(dot.dataset.gspLoveDot));
      startAutoplay();
    }));

    viewport.addEventListener('scroll', () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updatePagination);
    }, { passive: true });
    viewport.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(nearestIndex() + (event.key === 'ArrowRight' ? 1 : -1), true);
      startAutoplay();
    });
    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', resume);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) resume();
    });

    const visibilityHandler = () => startAutoplay();
    document.addEventListener('visibilitychange', visibilityHandler);
    const resizeHandler = () => window.requestAnimationFrame(updatePagination);
    window.addEventListener('resize', resizeHandler, { passive: true });

    carousel.gspLoveDestroy = () => {
      stopAutoplay();
      window.cancelAnimationFrame(animationFrame);
      document.removeEventListener('visibilitychange', visibilityHandler);
      window.removeEventListener('resize', resizeHandler);
    };

    updatePagination();
    startAutoplay();
  };

  const setup = (root = document) => {
    qsa('[data-gsp-love]:not([data-gsp-ready])', root).forEach(setupCarousel);
  };

  window.GoshkoCustomerLove = { setup };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup());
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    qsa('[data-gsp-love]', event.target).forEach((carousel) => carousel.gspLoveDestroy?.());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-gsp-love-card]');
    if (!card) return;
    const carousel = card.closest('[data-gsp-love]');
    const viewport = carousel?.querySelector('[data-gsp-love-viewport]');
    const cards = carousel ? qsa('[data-gsp-love-card]', carousel) : [];
    if (!viewport || cards.length === 0) return;
    viewport.scrollTo({
      left: card.offsetLeft - cards[0].offsetLeft,
      behavior: 'smooth'
    });
  });
})();
